const DEFERRED_MENTION_TYPES = new Set(["user"]);
const CUSTOM_SEARCH_MENTION_TYPES = new Set(["user", "uploadedDocument"]);
const UNSUPPORTED_MENTION_TYPES = new Set(["uploadedDocument", "attachment"]);
function normalizeMentionType(mentionType) {
    return mentionType === "attachment" ? "uploadedDocument" : mentionType;
}
export function getMentionInteractionKind(mentionType) {
    const normalized = normalizeMentionType(mentionType);
    if (DEFERRED_MENTION_TYPES.has(normalized)) {
        return "defer";
    }
    if (UNSUPPORTED_MENTION_TYPES.has(normalized)) {
        return "unsupported";
    }
    return normalized.trim().length > 0 ? "navigate" : "unsupported";
}
export function getMentionSearchBehavior(mentionType) {
    const normalized = normalizeMentionType(mentionType);
    if (CUSTOM_SEARCH_MENTION_TYPES.has(normalized)) {
        return "custom";
    }
    return getMentionInteractionKind(normalized) === "navigate" ? "entity" : "none";
}
export function listMentionSearchTypeKeys(options) {
    return ["user", ...options.enabledFrameworkEntityTypeKeys, "uploadedDocument"];
}
export function listMentionableEntityTypeKeysFromCatalog(catalog) {
    return (catalog?.entityTypes ?? [])
        .filter((entityType) => entityType.retiredAt == null)
        .map((entityType) => entityType.entityTypeKey);
}
export const listMentionSearchEntityTypeKeysFromCatalog = listMentionableEntityTypeKeysFromCatalog;
